<template>
  <div class="mission" v-hide="{ hide: !!mission.removed }" @hideComplete="hideComplete">
    <div class="d-flex justify-content-between align-items-start align-items-md-center flex-column flex-md-row">
      <div class="mission__label">
        <div class="mission__grip">
          <FontAwesomeIcon icon="fa-light fa-grip-lines-vertical" />
        </div>
        <div>
          <div>
            <span class="mission__code" v-if="mission.code">{{ mission.code }}</span>
            {{ mission.name }}
          </div>
          <div class="mission__badges" v-if="isBadge">
            <TrainingRncpSourceDetailsComponent :object="mission" @showDetails="showDetails" />
            <span class="badge bg-success" v-if="mission.jobOfferCount"
              >{{ mission.jobOfferCount }} {{ $t("training.rncp.badge.job_offer") }}</span
            >
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <div class="mission__actions">
          <button
            class="btn-icon btnEdit me-2"
            @click="edit"
            v-tooltip="{
              title: stringManager().globalTranslation('edit', 'mission', 'studea_manager', 1, true),
            }"
          >
            <FontAwesomeIcon icon="fa-light fa-pen" />
          </button>

          <button
            class="btn-icon btnRemove"
            @click="remove"
            v-tooltip="{
              title: stringManager().globalTranslation('delete', 'mission', 'studea_manager', 1, true),
            }"
          >
            <FontAwesomeIcon icon="fa-light fa-trash" />
          </button>
        </div>
      </div>
    </div>

    <div class="mission__questionnaires" v-if="mission.questionnaires && Object.keys(mission.questionnaires).length">
      <template v-for="questionnaire in mission.questionnaires" :key="questionnaire.id">
        <div class="d-flex align-items-center justify-content-between questionnaire">
          <div class="d-flex align-items-center">
            <span class="fw-bold">
              <FontAwesomeIcon icon="fa-light fa-user" class="me-2" />
              {{ $t("training.rncp.triad") }} : {{ questionnaire.triad.apprentice }}
            </span>
            <span class="ms-4">{{ questionnaire.triad.training }}</span>
            <span class="ms-4">{{ questionnaire.triad.trainingCourse }}</span>
          </div>
          <router-link
            class="ms-4 btn btn-icon"
            :to="{
              name: 'questionnaire',
              params: { triadId: questionnaire.triad.id, questionnaireId: questionnaire.id },
            }"
          >
            <FontAwesomeIcon icon="fa-light fa-eye" class="me-2" />
          </router-link>
        </div>
      </template>
    </div>
    <BlockLoader :loading="loading || mission.loading" size="small" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { trainingManager } from "@/services/training/training-manager";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { stringManager } from "@/services/utilities/string-manager";
import { trainingSkillConstante } from "@/constantes/trainingSkill";
import TrainingRncpSourceDetailsComponent from "@/components/training/rncp/TrainingRncpSourceDetailsComponent.vue";

export default {
  name: "TrainingSkillMissionComponent",
  components: { TrainingRncpSourceDetailsComponent, BlockLoader, FontAwesomeIcon },
  emits: ["editMission", "removed", "hideComplete", "showDetails"],
  props: {
    mission: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isBadge() {
      return this.hasSourceDetails || this.mission.jobOfferCount > 0;
    },

    hasSourceDetails() {
      return this.mission.sourceDetails && Object.keys(this.mission.sourceDetails);
    },

    isRome() {
      return this.mission.source && this.mission.source.includes("rome");
    },

    isTriad() {
      return this.mission.source && this.mission.source.includes("triad");
    },
  },
  methods: {
    stringManager() {
      return stringManager;
    },

    edit() {
      this.$emit("editMission", { mission: this.mission });
    },

    async remove() {
      this.loading = true;
      const done = await trainingManager.remove(this.mission.id, this.$route.params.trainingId, "mission", "mission");
      if (done && done.success) {
        this.$emit("removed", this.mission);
      }
      this.loading = false;
    },

    hideComplete() {
      this.$emit("hideComplete", this.mission);
    },

    showDetails() {
      this.$emit("showDetails", { object: this.mission, type: trainingSkillConstante.OBJECT_TYPE_MISSION });
    },
  },
};
</script>

<style lang="scss" scoped>
.mission {
  background: $lighter-grey;
  color: var(--primary-color);
  padding: 15px 20px;
  border-radius: $radius;
  border-left: 4px solid $orange;
  position: relative;

  @include dark-theme {
    background: $darker-grey;
    color: $white;
  }

  @include up-to-md {
    padding: 15px 10px;
    flex-direction: column;
  }

  &__actions {
    margin-left: 18px;
    min-width: 60px;

    @include up-to-md {
      margin-top: 10px;
    }
  }

  &__code {
    margin-right: 8px;
  }

  &__label {
    display: flex;
    align-items: center;
  }

  &__badges {
    margin-top: 10px;
    .badge + .badge {
      margin-left: 5px;
    }
  }

  &__questionnaires {
    margin-top: 20px;
  }

  &__grip {
    width: 20px;
    cursor: grab;
    min-width: 20px;
    margin-right: 8px;

    @include up-to-md {
      width: 15px;
      margin-right: 0;
    }
  }
}

.mission + .mission {
  margin-top: 20px;
}

.questionnaire {
  background: $light-orange;
  border: 1px solid $orange;
  padding: 10px;
  border-radius: $radius;
}
</style>
